module.exports = __webpack_public_path__ + "img/jingdian_qrcode.44e9e147.jpg";